// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 218) return "static/chunks/218.46dcb3e06be0bc0a.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 278 ? "00f54341" : chunkId) + "-" + {"92":"653150f24a569119","278":"130ab3d1cb18d75a","833":"87287eb107b3c6fa"}[chunkId] + ".js";
};